<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="pos pos-booking" id="pos-booking">
        <Header />
        <div class="pos-booking-body">
          <div class="pos-booking-content">
            <div
              class="pos-booking-content-container"
              data-scrollbar="true"
              data-height="100%"
              data-skip-mobile="true"
            >
              <TableStatus @loading="(value) => loading = value" />
              <TableComponent />
            </div>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
import Header from './components/header'
import TableStatus from './components/table-status'
import TableComponent from './components/table'
export default {
  name: 'tableBooking',
  components: {
    Header,
    TableStatus,
    TableComponent
  },
  data() {
    return {
      loading: false
    }
  },
  created() {
    PageOptions.pageEmpty = true
    PageOptions.pageFullHeight = true
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    PageOptions.pageFullHeight = false
    next()
  }
}
</script>